import { useTranslation } from "../contexts/TranslationContext";
import FunctionSection from '../components/FunctionSection';

const SapiooFunctions = () => {
  const { t } = useTranslation();

  return (
    <section className={'bg-defaultBg'}>
      <div className={'container mx-auto px-4 py-16'}>
        <h2 className={'text-2xl font-bold mb-8'}>
          {t('ourFunctions')}
        </h2>
        <div className={'grid gap-10 lg:gap-16 lg:grid-cols-[1fr_1px_1fr_1px_1fr]'}>
          <FunctionSection
            title={t('createForm')}
            items={[t('manageFormPages'), t('createFormInputs'), t('createFormDocuments'), t('useForms')]}
          />

          <div className={'bg-[#D9D9D9] hidden lg:block w-[1px] h-full'}></div>

          <FunctionSection
            title={t('checkInfo')}
            items={[t('validateData'), t('receiveFiles'), t('validateFiles'), t('requestAddInfo')]}
          />

          <div className={'bg-[#D9D9D9] hidden lg:block w-[1px] h-full'}></div>

          <FunctionSection
            title={t('manageSubmission')}
            items={[t('manageStatuses'), t('processSubmission'), t('emailCommunication'), t('shareFinalProduct')]}
          />
        </div>
      </div>
    </section>
  );
};

export default SapiooFunctions;